const $$splitComponentImporter = () => import('/home/runner/work/zngly-corporate/zngly-corporate/wp-content/themes/zngly-corporate/frontend/src/routes/dash/hubs/hubs/$hubEdit.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { setPageFullScreen } from '@/Components/templates/Page';
import { requireUserPostCaps } from '@/Router';
import { HubSingleQuery, type Hub_Single_Query, type Hub_Single_Query$data } from '@/graphql/queries/Hub.query';
import { RelayEnvironment } from '@/graphql/relay-env';
import { useAppStore } from '@/inertia/AppStore';
import { createFileRoute } from '@tanstack/react-router';
import { loadQuery } from 'react-relay';
type Props = {
  data?: Hub_Single_Query$data;
  isFallback?: boolean;
};
export type { Props as HubEditComponentProps };
export const Route = createFileRoute('/dash/hubs/hubs/$hubEdit')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr),
  onEnter: () => {
    useAppStore.setState({
      isAppPreview: true,
      barTitle: 'Content',
      pageType: 'hub'
    });
    setPageFullScreen('on');
  },
  onLeave: () => {
    useAppStore.setState({
      isAppPreview: false,
      pageType: null
    });
    setPageFullScreen('off');
  },
  beforeLoad: ({
    params
  }) => {
    requireUserPostCaps('hub', 'edit_post', {
      to: '/dash/hubs/hubs'
    });
  },
  loader: ({
    params
  }) => {
    return loadQuery<Hub_Single_Query>(RelayEnvironment, HubSingleQuery, {
      id: params.hubEdit
    }, {
      fetchPolicy: 'store-or-network'
    });
  }
});